import gql from 'graphql-tag';
import { apollo } from 'src/features';

const mutation = gql`
mutation loginUser($login: String, $password: String, $ucceAuthorizationToken: String, $ldapAuth: Boolean) {
  login(login: $login, password: $password, ucceAuthorizationToken: $ucceAuthorizationToken, ldapAuth: $ldapAuth) {
    userId
    role
    token
  }
}`;

function loginUser({
  login,
  password,
  ucceAuthorizationToken,
  ldapAuth,
}) {
  return apollo.client.mutate({
    variables: {
      login,
      password,
      ucceAuthorizationToken,
      ldapAuth,
    },
    mutation,
  })
    .then((res) => res.data.login)
    .catch((err) => {
      if (err.graphQLErrors.length) {
        throw err.graphQLErrors[0];
      } else {
        throw err;
      }
    });
}

export default loginUser;
